import type { ScenarioId } from '@finsim/model';
import { createEvent, createStore } from 'effector';
import { projectClosed } from '../../entities/project';

/** Collapsed variants in the tree (view state, not saved). */
export const variantToggled = createEvent<ScenarioId>();
export const $collapsed = createStore<ReadonlySet<ScenarioId>>(new Set())
  .on(variantToggled, (set, id) => {
    const next = new Set(set);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    return next;
  })
  .reset(projectClosed);

/** Which variant's "add item" menu is open (so the `C` shortcut can open it). */
export const addMenuOpened = createEvent<ScenarioId>();
export const addMenuClosed = createEvent();
export const $addMenuFor = createStore<ScenarioId | null>(null)
  .on(addMenuOpened, (_, id) => id)
  .reset(addMenuClosed, projectClosed);
